import { LargeButton, LargeButtonColor } from '../LargeButton/LargeButton';
import { Box } from '@material-ui/core';
import React from 'react';
import i18n from '../../../i18n';

export interface GalleryDialogFooterProps {
    onSave: () => void;
}

export const GalleryDialogFooter = (props: GalleryDialogFooterProps) => {
    const { onSave } = props;

    const { t } = i18n.useTranslation();
    return (
        <Box display="flex" alignItems="center" p={2}>
            <Box flex="1">{/* Upload button goes here */}</Box>
            <Box display="flex" flex="0 0 auto">
                <Box>
                    <LargeButton onClick={onSave}> {t('common:gallery.save')}</LargeButton>
                </Box>
            </Box>
        </Box>
    );
};
